import React from "react";
import ReactDOM from "react-dom";
import RejectRentingModal from "./index";

export default async function renderRejectRentingModal({
  target = "modal-container",
  ...rest
}) {
  const domTarget = document.getElementById(target);
  if (domTarget) {
    ReactDOM.render(<RejectRentingModal {...rest} />, domTarget);
  }
}
